export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">关于我们</h2>
        <p className="text-sm text-foreground-600 mb-8">关于51视频，你想了解的都在这儿</p>
        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-8 text-left">
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            51视频是一个专注于影视资源聚合与导航的在线平台。我们聚合了香蕉视频、红桃视频、91视频等多个热门影视站点的优质资源，致力于为广大影视爱好者提供一站式的观影导航服务。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed mb-4">
            我们的内容涵盖最新电影、热播电视剧、综艺节目、动漫番剧、纪录片等多种类型，每日更新超过2000部影视内容。无论您是追剧达人、电影发烧友还是综艺爱好者，都能在51视频找到心仪的内容入口。
          </p>
          <p className="text-sm text-foreground-600 leading-relaxed">
            51视频始终坚持"免费、高清、流畅"的服务理念，采用先进的CDN加速技术确保播放体验，同时不断优化内容分类与推荐算法，让每一位用户都能轻松发现好片、享受观影乐趣。我们注重用户体验，坚持不插入弹窗广告，营造清爽的浏览环境。
          </p>
        </div>
      </div>
    </section>
  );
}